import React, { useState, useEffect, useRef } from "react";
import {BotonAddPequeño, BotonDown, BotonMenosPequeño, BotonRemovePequeño, BotonPesar} from "../Plantillas/Botones";
import { decimalAdjust, TIPO_STOCK } from "../../Global";
import _ from "lodash";
import MagellanListener, { KILOGRAMO_UNIT_DESCRIPTION } from "../../helpers/MagellanListener";
import '../styles/DetalleProductoGrifo.css';

function DetallesProductoGrifos(props) {
    const [verPrecios, setVerPrecios] = useState(true);
    const [magellanListenerIsAvailable, setMagellanListenerIsAvailable] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    
    const tableRef = useRef(null);
    const queryParams = useRef(new URLSearchParams(window.location.search));

    // Verificar si se puede ver precio de costo
    const verificarPrecioCosto = async () => {
        try {
            const responseVal = await fetch(`/api/prices/precioCosto/validar`);
            const data = await responseVal.json();
            setVerPrecios(true);
        } catch (e) {
            setVerPrecios(false);
        }
    };

    // Recibir peso de balanza Magellan
    const onRecieveWeight = (weight, owner, addWeight) => {
        const detalle = props.detalles.find(p => p.IdProducto === owner);
        if (!detalle) return;

        props.InputCantidadDetalleChange({
            target: {
                value: addWeight ? (detalle.Cantidad + weight) - 1 : weight
            }
        }, detalle);
    };

    // Cambios en disponibilidad Magellan
    const onMagellanChangeAvailability = (availability) => {
        setMagellanListenerIsAvailable(availability);
    };

    // Solicitar peso
    const requestWeight = (detalle) => {
        const add = props.detalles.some(p => p.IdProducto === detalle.IdProducto);
        MagellanListener.requestWeight(detalle.IdProducto, add);
    };

    // Inicializar component
    useEffect(() => {
        setIsEditing(window.location.href.includes("/edit/"));
        
        // Registrar como subscriber de Magellan
        MagellanListener.addSubscriber({
            onRecieveWeight,
            onMagellanChangeAvailability
        });
        setMagellanListenerIsAvailable(MagellanListener.sourceIsRunning());
        
        verificarPrecioCosto();
    }, []);

    // Auto-scroll cuando se agregan productos
    useEffect(() => {
        if (tableRef.current && props.detalles.length >= 6) {
            const table = tableRef.current.querySelector('.grifos__tabla-container');
            if (table) {
                table.scrollTop = table.scrollHeight;
            }
        }
    }, [props.detalles.length]);

    let canUpdatePrice = !_.isUndefined(props.canUpdatePrice) ? props.canUpdatePrice : true;
    let canIncrementProductPrice = !!props.incrementarPrecioProd ? props.incrementarPrecioProd : false;
    
    return (
        <div id="tableDetProdGrifos" className="grifos__carrito mt-2" ref={tableRef}>
                <div className="grifos__tabla-container">
                    <table className="table table-sm table-hover grifos__tabla">
                        <thead className="grifos__cabecera">
                            <tr>
                                <th className="grifos__th-producto">Producto</th>
                                <th className="grifos__th-cantidad text-center">Cant.</th>
                                <th className="grifos__th-precio text-center">Precio</th>
                                <th className="grifos__th-total text-center">Total</th>
                                <th className="grifos__th-acciones text-center"></th>
                            </tr>
                        </thead>
                        <tbody id="IdDetProductoCarritoGrifos">
                        {
                            props.detalles.map((det, i) => {
                                return (
                                    <tr
                                        id={`producto-grifo-${det.IdPresentacion}`}
                                        key={`det-grifo-${det.IdPresentacion}`}
                                        className={`grifos__fila ${det.IdTipoStock === TIPO_STOCK.CON_COMPROBANTE ? "" : "grifos__fila--sin-comprobante"}`}
                                        onKeyUp={(e) => props.onSecretKeyPress(e, det)}
                                    >
                                        {/* Columna Producto */}
                                        <td className="grifos__td-producto">
                                            <div className="grifos__producto-info">
                                                <div className="grifos__producto-nombre">
                                                    <span className="grifos__nombre-normal">
                                                        {det.descripcion} {det.unidadMedida}
                                                    </span>
                                                    {/* {String(det.EsFacturable) === "1" ? (
                                                        <span className="grifos__nombre-normal">
                                                            {det.descripcion} {det.unidadMedida}
                                                        </span>
                                                    ) : (
                                                        <span className="grifos__nombre-especial">
                                                            {det.descripcion} {det.unidadMedida}
                                                        </span>
                                                    )} */}
                                                </div>
                                                
                                                {/* Opciones de precio y costo */}
                                                {/* {!this.state.isEditing && (
                                                    <div className="grifos__opciones-precio">
                                                        {this.props.venderConListaPrecios === 1 && (
                                                            <select
                                                                required
                                                                disabled={this.props.load}
                                                                className="grifos__select-precio"
                                                                value={det.Precio}
                                                                onChange={(e) => this.props.PrecioChange(e, det)}
                                                            >
                                                                <option value={det.PrecioMenor}>Menor/Lista</option>
                                                                <option value={det.PrecioFamiliar}>Familiar</option>
                                                                <option value={det.PrecioEspecial}>Especial</option>
                                                            </select>
                                                        )}
                                                        
                                                        {this.state.verPrecios && (
                                                            <div className="grifos__precio-costo">
                                                                <small>
                                                                    Costo: S/ {det.PrecioVenta.toLocaleString("en-GB", {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </div>
                                                )} */}
                                            </div>
                                        </td>

                                        {/* Columna Cantidad */}
                                        <td className="grifos__td-cantidad text-center">
                                                <input
                                                    onClick={(e) => e.target.select()}
                                                    readOnly={true}
                                                    type="number"
                                                    className="abed__grifos__input grifos__input--cantidad grifos__input--readonly"
                                                    step="1"
                                                    min="1"
                                                    name="Cantidad"
                                                    disabled={true}
                                                    value={det.Cantidad}
                                                    onChange={e => props.InputCantidadDetalleChange(e, det)}
                                                    onBlur={e => props.onBlurInputCantidad(e, det)}
                                                />
                                        </td>

                                        {/* Columna Precio */}
                                        <td className="grifos__td-precio text-center">
                                            <input
                                                onClick={(e) => e.target.select()}
                                                readOnly={true}
                                                type="number"
                                                className="abed__grifos__input grifos__input--precio grifos__input--readonly"
                                                step="0.01"
                                                min="0"
                                                disabled={true}
                                                value={det.PrecioVenta}
                                                name="PrecioVenta"
                                            />
                                        </td>

                                        {/* Columna Total */}
                                        <td className="grifos__td-total text-center">
                                            <input 
                                                type="number"
                                                readOnly={true}
                                                disabled={true}
                                                onChange={e => props.onChangeTotal(e, det)}
                                                onBlur={e => props.onBlurTotal(e, det)}
                                                onClick={e => e.target.select()}
                                                className="abed__grifos__input grifos__input--total grifos__input--readonly"
                                                value={decimalAdjust('round', det.Total - (det.Total * props.descuentoPorCliente/100), -2)}
                                            />
                                        </td>

                                        {/* Columna Acciones */}
                                        <td className="grifos__td-acciones text-center">
                                            {queryParams.current.get('disabled') !== 'true' && (
                                                <div className="grifos__acciones-container">
                                                    {/* {(magellanListenerIsAvailable && 'unidadMedida' in det && det.unidadMedida === KILOGRAMO_UNIT_DESCRIPTION) ? (
                                                        <BotonPesar 
                                                            disabled={props.load}
                                                            className="grifos__boton grifos__boton--pesar"
                                                            type="button"
                                                            title="Pesar"
                                                            onClick={() => requestWeight(det)}
                                                        />
                                                    ) : (
                                                        <div className="grifos__botones-cantidad">
                                                            <BotonMenosPequeño
                                                                disabled={props.load}
                                                                className="grifos__boton grifos__boton--menos"
                                                                type="button"
                                                                title="Disminuir en 1"
                                                                onClick={() => props.RestarCantidadDet(det)}
                                                            />
                                                            <BotonAddPequeño
                                                                disabled={props.load}
                                                                className="grifos__boton grifos__boton--mas"
                                                                type="button"
                                                                title="Aumentar en 1"
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    props.AgregarCantidadDet(det)
                                                                }}
                                                            />
                                                        </div>
                                                    )} */}
                                                    
                                                    {/* <div className="grifos__botones-acciones">
                                                        <BotonRemovePequeño
                                                            disabled={props.load}
                                                            className="grifos__boton grifos__boton--eliminar"
                                                            type="button"
                                                            title="Quitar item"
                                                            onClick={() => props.RemoveProductoInList(det)}
                                                        />
                                                        <BotonDown
                                                            disabled={props.load}
                                                            className="grifos__boton grifos__boton--descuento"
                                                            onClick={() => props.handleOpenModalDescuento(det)}
                                                            title="Descuento"
                                                        />
                                                    </div> */}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </div>

                {/* Mostrar mensaje cuando no hay productos */}
                {props.detalles.length === 0 && (
                    <div className="grifos__mensaje-vacio">
                        <div className="grifos__mensaje-contenido">
                            <h3><i className="fas fa-gas-pump grifos__icono-vacio"></i> No hay productos seleccionados</h3>
                        </div>
                    </div>
                )}
            </div>
        );
}

export default DetallesProductoGrifos;